// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProposalPageScreen_pageHeader__H9-rz {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid var(--border);
  margin-bottom: 16px;
}
.ProposalPageScreen_pageHeader__H9-rz h1 {
  font: var(--h3);
  font-weight: 700;
  color: var(--primary-Text);
  font-family: var(--font-bodoni-72);
}
.ProposalPageScreen_pageHeader__H9-rz .ProposalPageScreen_right__f0vEg {
  display: flex;
  align-items: center;
  gap: 20px;
}
.ProposalPageScreen_pageHeader__H9-rz .ProposalPageScreen_right__f0vEg .ProposalPageScreen_date__Zo0HZ {
  display: flex;
  align-items: center;
  gap: 4px;
}
.ProposalPageScreen_pageHeader__H9-rz .ProposalPageScreen_right__f0vEg .ProposalPageScreen_date__Zo0HZ img,
.ProposalPageScreen_pageHeader__H9-rz .ProposalPageScreen_right__f0vEg .ProposalPageScreen_date__Zo0HZ svg {
  width: 16px;
  height: 16px;
  object-fit: scale-down;
  display: block;
}
.ProposalPageScreen_pageHeader__H9-rz .ProposalPageScreen_right__f0vEg .ProposalPageScreen_date__Zo0HZ span {
  font: var(--body-font-four);
  color: var(--primary-Text);
  display: block;
}

.ProposalPageScreen_ProposalPageScreenMain__nc9kc {
  padding: 0 24px;
}
.ProposalPageScreen_ProposalPageScreenMain__nc9kc .ProposalPageScreen_ProposalPageScreen__cKnj2 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  padding: 16px 0;
}
@media screen and (max-width: 1420px) {
  .ProposalPageScreen_ProposalPageScreenMain__nc9kc .ProposalPageScreen_ProposalPageScreen__cKnj2.ProposalPageScreen_sidebarExpand__8oL5y {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media screen and (max-width: 1040px) {
  .ProposalPageScreen_ProposalPageScreenMain__nc9kc .ProposalPageScreen_ProposalPageScreen__cKnj2.ProposalPageScreen_sidebarExpand__8oL5y {
    grid-template-columns: repeat(1, 1fr);
  }
}
@media screen and (max-width: 768px) {
  .ProposalPageScreen_ProposalPageScreenMain__nc9kc .ProposalPageScreen_ProposalPageScreen__cKnj2.ProposalPageScreen_sidebarExpand__8oL5y {
    grid-template-columns: repeat(1, 1fr);
  }
}
@media screen and (max-width: 1200px) {
  .ProposalPageScreen_ProposalPageScreenMain__nc9kc .ProposalPageScreen_ProposalPageScreen__cKnj2 {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media screen and (max-width: 870px) {
  .ProposalPageScreen_ProposalPageScreenMain__nc9kc .ProposalPageScreen_ProposalPageScreen__cKnj2 {
    grid-template-columns: repeat(1, 1fr);
  }
}

.ProposalPageScreen_detailModalIcon__bx4wg {
  background-color: var(--brand) !important;
}

.ProposalPageScreen_formWrp__o0VFD {
  max-height: 550px;
  overflow-y: auto;
}
.ProposalPageScreen_formWrp__o0VFD .ProposalPageScreen_formField__xV0G\\+ .ProposalPageScreen_label__nl6JS {
  font: var(--body-font-three);
  color: var(--secondary-Text);
  display: block;
  margin-bottom: 4px;
}
.ProposalPageScreen_formWrp__o0VFD .ProposalPageScreen_prioritySelect__M1Q8R {
  display: flex;
  align-items: center;
  gap: 5px;
  font: var(--body-font-four);
  font-weight: 500;
  text-transform: capitalize;
  color: var(--primary-Text);
}
.ProposalPageScreen_formWrp__o0VFD .ProposalPageScreen_prioritySelect__M1Q8R img,
.ProposalPageScreen_formWrp__o0VFD .ProposalPageScreen_prioritySelect__M1Q8R svg {
  width: 16px;
  height: 16px;
  object-fit: scale-down;
  display: block;
}
.ProposalPageScreen_formWrp__o0VFD .ProposalPageScreen_fileUploadedList__gBCqj {
  padding: 12px;
  width: 100%;
  justify-content: flex-start;
}
.ProposalPageScreen_formWrp__o0VFD .ProposalPageScreen_fileUploadedList__gBCqj span {
  color: var(--brand);
  flex: 1 1;
}`, "",{"version":3,"sources":["webpack://./src/components/Proposal/ProposalPageScreen.module.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,sCAAA;EACA,mBAAA;AACD;AACC;EACC,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,kCAAA;AACF;AAEC;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AAAF;AAEE;EACC,aAAA;EACA,mBAAA;EACA,QAAA;AAAH;AAEG;;EAEC,WAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;AAAJ;AAGG;EACC,2BAAA;EACA,0BAAA;EACA,cAAA;AADJ;;AAOA;EACC,eAAA;AAJD;AAMC;EACC,aAAA;EACA,qCAAA;EACA,SAAA;EACA,eAAA;AAJF;AAOG;EADD;IAEE,qCAAA;EAJF;AACF;AAMG;EALD;IAME,qCAAA;EAHF;AACF;AAKG;EATD;IAUE,qCAAA;EAFF;AACF;AAKE;EApBD;IAqBE,qCAAA;EAFD;AACF;AAIE;EAxBD;IAyBE,qCAAA;EADD;AACF;;AAKA;EACC,yCAAA;AAFD;;AAKA;EACC,iBAAA;EACA,gBAAA;AAFD;AAKE;EACC,4BAAA;EACA,4BAAA;EACA,cAAA;EACA,kBAAA;AAHH;AAOC;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,2BAAA;EACA,gBAAA;EACA,0BAAA;EACA,0BAAA;AALF;AAOE;;EAEC,WAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;AALH;AASC;EACC,aAAA;EACA,WAAA;EACA,2BAAA;AAPF;AASE;EACC,mBAAA;EACA,SAAA;AAPH","sourcesContent":[".pageHeader {\r\n\tdisplay: flex;\r\n\tjustify-content: space-between;\r\n\talign-items: center;\r\n\tpadding: 16px 24px;\r\n\tborder-bottom: 1px solid var(--border);\r\n\tmargin-bottom: 16px;\r\n\r\n\th1 {\r\n\t\tfont: var(--h3);\r\n\t\tfont-weight: 700;\r\n\t\tcolor: var(--primary-Text);\r\n\t\tfont-family: var(--font-bodoni-72);\r\n\t}\r\n\r\n\t.right {\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\tgap: 20px;\r\n\r\n\t\t.date {\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 4px;\r\n\r\n\t\t\timg,\r\n\t\t\tsvg {\r\n\t\t\t\twidth: 16px;\r\n\t\t\t\theight: 16px;\r\n\t\t\t\tobject-fit: scale-down;\r\n\t\t\t\tdisplay: block;\r\n\t\t\t}\r\n\r\n\t\t\tspan {\r\n\t\t\t\tfont: var(--body-font-four);\r\n\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\tdisplay: block;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.ProposalPageScreenMain {\r\n\tpadding: 0 24px;\r\n\r\n\t.ProposalPageScreen {\r\n\t\tdisplay: grid;\r\n\t\tgrid-template-columns: repeat(3, 1fr);\r\n\t\tgap: 20px;\r\n\t\tpadding: 16px 0;\r\n\r\n\t\t&.sidebarExpand {\r\n\t\t\t@media screen and (max-width: 1420px) {\r\n\t\t\t\tgrid-template-columns: repeat(2, 1fr);\r\n\t\t\t}\r\n\r\n\t\t\t@media screen and (max-width: 1040px) {\r\n\t\t\t\tgrid-template-columns: repeat(1, 1fr);\r\n\t\t\t}\r\n\r\n\t\t\t@media screen and (max-width: 768px) {\r\n\t\t\t\tgrid-template-columns: repeat(1, 1fr);\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t@media screen and (max-width: 1200px) {\r\n\t\t\tgrid-template-columns: repeat(2, 1fr);\r\n\t\t}\r\n\r\n\t\t@media screen and (max-width: 870px) {\r\n\t\t\tgrid-template-columns: repeat(1, 1fr);\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.detailModalIcon {\r\n\tbackground-color: var(--brand) !important;\r\n}\r\n\r\n.formWrp {\r\n\tmax-height: 550px;\r\n\toverflow-y: auto;\r\n\r\n\t.formField {\r\n\t\t.label {\r\n\t\t\tfont: var(--body-font-three);\r\n\t\t\tcolor: var(--secondary-Text);\r\n\t\t\tdisplay: block;\r\n\t\t\tmargin-bottom: 4px;\r\n\t\t}\r\n\t}\r\n\r\n\t.prioritySelect {\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\tgap: 5px;\r\n\t\tfont: var(--body-font-four);\r\n\t\tfont-weight: 500;\r\n\t\ttext-transform: capitalize;\r\n\t\tcolor: var(--primary-Text);\r\n\r\n\t\timg,\r\n\t\tsvg {\r\n\t\t\twidth: 16px;\r\n\t\t\theight: 16px;\r\n\t\t\tobject-fit: scale-down;\r\n\t\t\tdisplay: block;\r\n\t\t}\r\n\t}\r\n\r\n\t.fileUploadedList {\r\n\t\tpadding: 12px;\r\n\t\twidth: 100%;\r\n\t\tjustify-content: flex-start;\r\n\r\n\t\tspan {\r\n\t\t\tcolor: var(--brand);\r\n\t\t\tflex: 1;\r\n\t\t}\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageHeader": `ProposalPageScreen_pageHeader__H9-rz`,
	"right": `ProposalPageScreen_right__f0vEg`,
	"date": `ProposalPageScreen_date__Zo0HZ`,
	"ProposalPageScreenMain": `ProposalPageScreen_ProposalPageScreenMain__nc9kc`,
	"ProposalPageScreen": `ProposalPageScreen_ProposalPageScreen__cKnj2`,
	"sidebarExpand": `ProposalPageScreen_sidebarExpand__8oL5y`,
	"detailModalIcon": `ProposalPageScreen_detailModalIcon__bx4wg`,
	"formWrp": `ProposalPageScreen_formWrp__o0VFD`,
	"formField": `ProposalPageScreen_formField__xV0G+`,
	"label": `ProposalPageScreen_label__nl6JS`,
	"prioritySelect": `ProposalPageScreen_prioritySelect__M1Q8R`,
	"fileUploadedList": `ProposalPageScreen_fileUploadedList__gBCqj`
};
export default ___CSS_LOADER_EXPORT___;
